<div [formGroup]="addressForm" class="input-wrapper">
  <ng-container *ngIf="!isManualAddress; else manualAddress">
    <hospitality-bot-auto-complete
      controlName="addressData"
      [label]="label"
      class="auto-complete"
      [options]="addressList"
      [loading]="loading"
      (onSearch)="searchOptions($event)"
      [settings]="{
        multiple: false
      }"
      [props]="{
        errorMessages: {
          required: 'This is a required field.'
        },
        placeholder: 'Search Address'
      }"
    >
    </hospitality-bot-auto-complete>

    <button
      class="address-mode-toggle"
      type="button"
      (click)="useManualAddress()"
    >
      + Use Manual Address
    </button>
  </ng-container>

  <ng-template #manualAddress>
    <hospitality-bot-input
      controlName="apartment"
      label="Apartment"
      [props]="{
        placeholder: 'Enter Apartment'
      }"
    ></hospitality-bot-input>

    <hospitality-bot-input
      controlName="addressLine"
      label="Address Line"
      [props]="{
        placeholder: 'Enter Address Line',
        errorMessages: {
          required: 'This is a required field.'
        }
      }"
    ></hospitality-bot-input>

    <hospitality-bot-input
      controlName="state"
      label="State"
      [props]="{
        placeholder: 'Enter State',
        errorMessages: {
          required: 'This is a required field.'
        }
      }"
    ></hospitality-bot-input>

    <hospitality-bot-input
      controlName="postalCode"
      label="Postal Code"
      [props]="{
        placeholder: 'Enter Postal Code',
        errorMessages: {
          required: 'This is a required field.'
        }
      }"
    ></hospitality-bot-input>

    <hospitality-bot-input
      controlName="city"
      label="City"
      [props]="{
        placeholder: 'Enter City',
        errorMessages: {
          required: 'This is a required field.'
        }
      }"
    ></hospitality-bot-input>

    <hospitality-bot-input
      controlName="country"
      label="Country"
      [props]="{
        placeholder: 'Enter Country',
        errorMessages: {
          required: 'This is a required field.'
        }
      }"
    ></hospitality-bot-input>

    <button
      class="address-mode-toggle"
      type="button"
      (click)="useSearchAddress()"
    >
      + Use Search Address
    </button>
  </ng-template>

  <div hidden="true">{{ getValidator }}</div>
</div>
